<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let chosen_segment, segments;
    export let disabled = true; //TODO: fix this being the wrong way around

    function handle_key_press(e, segment) {
        if (e.key === "Enter") {
            chosen_segment = segment;
        }
    }
    function handle_click(segment) {
        chosen_segment = segment;
    }
</script>

<div class="segmented-control-flex mb-2 {disabled
                        ? ''
                        : 'custom-disabled'}">
    {#each segments as segment}
        <div
            class={segment == chosen_segment ? "segment active" : "segment"}
            on:click={handle_click(segment)}
            on:keypress={(e) => {
                handle_key_press(e, segment);
            }}
        >
            {segment}
        </div>
    {/each}
</div>
